import { render, staticRenderFns } from "./ProjectView.vue?vue&type=template&id=0524d20f&scoped=true"
import script from "./ProjectView.vue?vue&type=script&lang=js"
export * from "./ProjectView.vue?vue&type=script&lang=js"
import style0 from "./ProjectView.vue?vue&type=style&index=0&id=0524d20f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0524d20f",
  null
  
)

export default component.exports